module.exports = __webpack_public_path__ + "img/Stones2.2d7c3a34.jpg";